import { Checkbox, Radio } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  id?: string;
  name?: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  disabled?: boolean;
  singleSelect?: boolean;
}

export const QcsCheckbox: FC<Props> = ({
  className,
  id,
  name,
  checked,
  indeterminate,
  onChange,
  disabled,
  singleSelect = false,
}) => {
  return singleSelect ? (
    <Radio
      className={className}
      id={id}
      name={name}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
  ) : (
    <Checkbox
      className={className}
      id={id}
      name={name}
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      disabled={disabled}
    />
  );
};
